import {Link} from "react-router-dom";
import "./styles/cpa.scss";
import { motion } from "framer-motion"
import ServiceNavbar from "./components/ServiceNavbar";

function Cpa() {
    return (
        <>
            {/* <!-- banner --> */}
            <div className="banner">
                <motion.div
                        initial={{ opacity: 0, x:-100 }}
                        whileInView={{ opacity: 1, x:0 }}
                        transition={{
                        delay: 0.4,
                        default: { ease: "linear" },
                        }}>
                    <img src="./cpaImg/CPA.jpg" alt=""/>
                </motion.div>
                <div className="cpabannertext dis">
                    Becker<br/>
                    CPA<br/>
                    <div className="fs-1 dis">
                        Exam Review
                    </div>
                    <div className="fx dis">
                        <button type="button" className="btn btn-outline-secondary dis"><a href="#why" className="text-secondary">詳情介紹</a></button>
                        <button type="button" className="btn btn-secondary dis me-3"><Link className="text-light" to={`/registration/plan?parent_id=1`}>申請報名</Link></button>
                    </div>
                </div>
            </div>
            {/* <!-- Service Nav--> */}
            <ServiceNavbar/>
            {/* <!-- CPAsubNav --> */}
            <div className="container-fluid bgb">
                <div className="container">
                    <div className="cpasubnav">
                        <a href="#why"><div>Why USCPA</div></a>
                        <a href="#examsubjects"><div>考試科目與<br/>題型配比</div></a>
                        <a href="#examtimeline"><div>考試時間與<br/>成績保留原則</div></a>
                        <a href="#eligibility"><div>應考步驟與<br/>報考資格</div></a>
                        <a href="#protocol"><div>雙照計劃</div></a>
                        <a href="#protocol2"><div>證照互認協議</div></a>
                        <a href="#whybeckertw"><div>Why Becker<br/>Why Becker Taiwan</div></a>
                        <a href="#intro"><div>方案介紹</div></a>
                    </div>
                </div>
            </div>
            {/* <!-- CPA --> */}
            <div className="beckertitlename mb100 mt100" id="why">Why USCPA</div>
            <div className="container whycpa mb100">
                <div className="col-xs-12 col-md-3 sixsq">
                <div className="sqcard">
                        <div className="side mt-5">
                        <img src="./cpaImg/cpa_icon_01.svg" alt=""/>
                            <div className="fs-5">美國法律保障</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-5">美國註冊會計師 (Certified Public Accountant，簡稱 CPA) 執照具美國法律約束力與保障，由美國會計師協會 (AICPA) 舉辦統一會計師考試、由各州依法核發執照。</div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-3 sixsq">
                <div className="sqcard">
                        <div className="side mt-5">
                        <img src="./cpaImg/cpa_icon_02.svg" alt=""/>
                            <div className="fs-5">全球會計師始祖</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-3">美國會計師是全球第一個需通過會計專業考試取得的執業證照，也是全球會計師(CPA) 的始祖，推行至今已逾百年，在全球各國皆享有高認可度，是世界上規模最大、最為國際化的法定會計師專業資格。</div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-3 sixsq">
                <div className="sqcard">
                        <div className="side mt-5">
                        <img src="./cpaImg/cpa_icon_03.svg"alt=""/>
                            <div className="fs-5">國際職場競爭力</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-3">全球化影響下，跨國企業對「具有國際證照的財會人才」需求大增，會計專業更因可與不同產業結合，發展性隨之加大；美國 CPA 可結合並抵換多國財會專業證照，對需要取得 CPA 執業頭銜、瞭解美國會計制度的管理者而言，除了增加在跨國職場上的競爭力外，更可提升個人專業信用度與權威。</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container whycpa mb100">
                <div className="col-xs-12 col-md-3 sixsq">
                <div className="sqcard">
                        <div className="side mt-5">
                        <img src="./cpaImg/cpa_icon_04.svg"alt=""/>
                            <div className="fs-5">國際高度專業能力</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-3">美國 CPA 是國際性會計師事務所、政府單位招募指標，更是跨國企業、外商公司炙手可熱的高薪人才。通過美國會計師考試，代表分析判斷、思考視野以及語文能力皆符合國際水準，並擁有跨國商業溝通的高度專業能力。</div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-3 sixsq">
                <div className="sqcard">
                        <div className="side mt-5">
                        <img src="./cpaImg/cpa_icon_05.svg"alt=""/>
                            <div className="fs-5">留學、移民絕對優勢</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-3">通過 CPA 考試者，在赴美留學、申請名校時佔加分優勢，畢業後取得當地實習機會較同期畢業生更大，獲得正式工作機會也較不具 CPA 資格之留學生多，是移民美國、技術移民澳洲及加拿大並立即進入當地職場的快捷方式。</div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-3 sixsq">
                <div className="sqcard">
                        <div className="side mt-5">
                        <img src="./cpaImg/cpa_icon_06.svg"alt=""/>
                            <div className="fs-5">全球趨勢、國際認可</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-3">通過美國會計師考試代表熟悉 IFRS 與 U.S. GAAP 會計雙準則，更強調對美國法規和商業環境的瞭解；持有美國會計師，在國際會計師事務所或跨國企業中，和跨國同事協力工作、或和國際客戶商談生意時，將賦予有力話語權與說服力。</div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- USCPA 有助生涯&職涯規劃 --> */}
            <div className="container mb100 mt100">
                <div className="br mt100 mb100"></div>
                <div className="beckertitlename mb100 mt100">USCPA 有助生涯&職涯規劃</div>
                <motion.div
                            initial={{ opacity: 0, x:-100 }}
                            whileInView={{ opacity: 1, x:0 }}
                            transition={{
                            delay: 0.4,
                            default: { ease: "linear" },
                        }}>
                <div className="d-flex justify-content-around cpaappliancearea">
                    <div className="cpaappliance">
                        <div className="sqcontent">
                            <div className="sqtitle">在職人士</div>
                            <div className="sqdes">專業強化/交換工作/職務晉升/職涯轉換/自行開業/國際移動</div>
                        </div>
                    </div>
                    <div className="cpaappliance">
                        <div className="sqcontent">
                            <div className="sqtitle">留學生</div>
                            <div className="sqdes">申請名校/Pre-MBA專業訓練/申請工作實習/爭取實習後留任</div>
                        </div>
                    </div>
                    <div className="cpaappliance">
                        <div className="sqcontent">
                            <div className="sqtitle">大學生</div>
                            <div className="sqdes">就業前的專業預備/抵免台會雙照計畫</div>
                        </div>
                    </div>
                    <div className="cpaappliance">
                        <div className="sqcontent">
                            <div className="sqtitle">移民需求</div>
                            <div className="sqdes">申請美國移民加分/技術移民澳洲、加拿大、新加坡的快捷方式</div>
                        </div>
                    </div>
                </div>
                </motion.div>
                <div className="br mt100 mb100"></div>
                {/* <!-- 考試科目與題型配比 --> */}
                <div className="beckertitlename mb100 mt100" id="examsubjects">考試科目與題型配比</div>
                <div className="examtable">
                    <div className="examsubjects fr  ">
                        <img className="" src="./cpaImg/far.svg"alt=""/>
                        <div className="subjectname ">FAR</div>
                        <div className="fullname ">Financial Accounting & Reporting</div>
                        <div className="chmean ">財務會計與報告</div>
                        <div className="des">一般公認會計準則(GAAP)，包含企業、非營利事業和政府會計</div>
                        <div className="examtime tfr">考試時間：4小時</div>
                        <div className="qutype mfr">
                            <ul>
                                <li>
                                    <span className="mma">題型</span>
                                    <span className="mmt">配比</span>
                                </li>
                                <li>
                                    <span className="mma">單選題 (MCQ) 50題</span>
                                    <span className="mmt">50%</span>
                                </li>
                                <li>
                                    <span className="mma">情境模擬題 (Task-based Simulation)7大題</span>
                                    <span className="mmt">50%</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="examsubjects au ">
                        <img className="" src="./cpaImg/aud.svg"alt=""/>
                        <div className="subjectname">AUD</div>
                        <div className="fullname">Auditing & Attestation</div>
                        <div className="chmean">審計與鑑證</div>
                        <div className="des">審計服務、簽證服務、<br/>會計及核閱服務</div>
                        <div className="examtime tau">考試時間：4小時</div>
                        <div className="qutype mau">
                            <ul>
                                <li>
                                    <span className="mma">題型</span>
                                    <span className="mmt">配比</span>
                                </li>
                                <li>
                                    <span className="mma">單選題 (MCQ) 78題</span>
                                    <span className="mmt">50%</span>
                                </li>
                                <li>
                                    <span className="mma">Task-Based Simulation 7大題</span>
                                    <span className="mmt">50%</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="examsubjects rg  ">
                        <img className="" src="./cpaImg/reg.svg"alt=""/>
                        <div className="subjectname">REG</div>
                        <div className="fullname">Taxation and Regulation</div>
                        <div className="chmean">稅務與法規</div>
                        <div className="des">美國聯邦稅法、定期性或一次性個人與企業稅務處理、商事法</div>
                        <div className="examtime trg">考試時間：4小時</div>
                        <div className="qutype mrg">
                            <ul>
                                <li>
                                    <span className="mma">題型</span>
                                    <span className="mmt">配比</span>
                                </li>
                                <li>
                                    <span className="mma">單選題72題</span>
                                    <span className="mmt">50%</span>
                                </li>
                                <li>
                                    <span className="mma">Task-Based Simulation 8大題</span>
                                    <span className="mmt">50%</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                </div>
                <div className="beckertitlename mb100 mt100" id="examsubjects">專科 (discipline) 考試</div>
                <div className="examtable">
                    <div className="examsubjects br  ">
                        <img className="" src="./cpaImg/far.svg"alt=""/>
                        <div className="subjectname ">BAR</div>
                        <div className="fullname ">Business Analysis and Reporting</div>
                        <div className="chmean ">商業分析與報告</div>
                        <div className="des">成本會計、財報分析、政府會計、財務管理、風險管理</div>
                        <div className="examtime tbr">考試時間：4小時</div>
                        <div className="qutype mbr">
                            <ul>
                                <li>
                                    <span className="mma">題型</span>
                                    <span className="mmt">配比</span>
                                </li>
                                <li>
                                    <span className="mma">單選題 (MCQ) 50題</span>
                                    <span className="mmt">50%</span>
                                </li>
                                <li>
                                    <span className="mma">情境模擬題 (Task-based Simulation)7大題</span>
                                    <span className="mmt">50%</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="examsubjects ic  ">
                        <img className="" src="./cpaImg/aud.svg"alt=""/>
                        <div className="subjectname">ISC</div>
                        <div className="fullname">Information Systems and Controls</div>
                        <div className="chmean">資訊系統與控制</div>
                        <div className="des">資訊系統、資料管理、資安機密、服務組織控制報告 (SOC)</div>
                        <div className="examtime tic">考試時間：4小時</div>
                        <div className="qutype mic">
                            <ul>
                                <li>
                                    <span className="mma">題型</span>
                                    <span className="mmt">配比</span>
                                </li>
                                <li>
                                    <span className="mma">單選題 (MCQ) 82題</span>
                                    <span className="mmt">60%</span>
                                </li>
                                <li>
                                    <span className="mma">情境模擬題 (Task-based Simulation) 6大題</span>
                                    <span className="mmt">40%</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="examsubjects tp  ">
                        <img className="" src="./cpaImg/reg.svg"alt=""/>
                        <div className="subjectname">TCP</div>
                        <div className="fullname">Tax Compliance and Planning</div>
                        <div className="chmean">稅務遵循與規劃</div>
                        <div className="des">美國聯邦稅法、個人與企業之非固定稅務處理、稅務規劃、個人財務規劃</div>
                        <div className="examtime ttp">考試時間：4小時</div>
                        <div className="qutype mtp">
                            <ul>
                                <li>
                                    <span className="mma">題型</span>
                                    <span className="mmt">配比</span>
                                </li>
                                <li>
                                    <span className="mma">單選題68題</span>
                                    <span className="mmt">50%</span>
                                </li>
                                <li>
                                    <span className="mma">情境模擬題 (Task-based Simulation) 7大題</span>
                                    <span className="mmt">50%</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                </div>
                <div className="br mn100 mt100"></div>
                {/* <!-- 四科考試架構及考試注意事項 --> */}
                <div className="beckertitlename mb-5 mt100">各科考試架構、範圍簡介</div>
                <div className="text-center w-75 m-auto">
                美國註冊會計師考試為觀念導向的考試，考生應全面了解考試概念及內容重點，正確判斷題意之外，
                也要有靈活思考以增快答題速度。另外可從題目練習之中學習答題技巧及方向，而非死背答案。
                </div>
                <div className="d-flex subjecttable mb100 mt100">
                    <motion.div
                                initial={{ opacity: 0, x:-100 }}
                                whileInView={{ opacity: 1, x:0 }}
                                transition={{
                                delay: 0.4,
                                default: { ease: "linear" },
                            }}>
                        <div className="col-4 dis">
                            <img className="subpic" src="./cpaImg/far_pic.jpg" alt=""/>
                        </div>
                    </motion.div>
                    <div className="col-8">
                        <div className="fs-1 mb-3">Financial Accounting & Reporting</div>
                        <div className="mb100">「FAR 財務會計」是新制考試的學科 (core exams) 之一，每個考生都必須通過 FAR；這也是台灣人相對最熟悉、學習底子最好的一科，往年通過率皆比其他學科 (審計與法規) 更高。

                        此科範圍包含一般公認會計準則 (U.S. GAAP)，以及企業、非營利事業、政府會計，選擇 FAR 作為第一科準備的考試，是個好的起點，為後續準備其他科目預先建立基礎概念。

                        備考過程中，應注意國內 IFRS 及美國 U.S. GAAP 會計準則之差異，同時對美國的財會公報體系應有一定程度的瞭解。相信只要充份使用 Becker 教材刷題練習，考生應可順利通過此科。
                        </div>
                        <ul>
                            <li className="tsti">
                                <span className="tmxl">出題範圍</span>
                                <span className="tmm">題型配比</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area I</span>
                                <span className="tml">Financial Reporting</span>
                                <span className="tmm">財務報告</span>
                                <span className="tmm">30-40%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area II</span>
                                <span className="tml">Select Balance Sheet Accounts</span>
                                <span className="tmm">特定資產負債表科目</span>
                                <span className="tmm">30-40%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area III</span>
                                <span className="tml">Select Transactions</span>
                                <span className="tmm">特定交易</span>
                                <span className="tmm">25-35%</span>
                            </li>
                        </ul>
                    </div>
                </div>
                
                <div className="d-flex subjecttable mb100">
                    <motion.div
                                initial={{ opacity: 0, x:-100 }}
                                whileInView={{ opacity: 1, x:0 }}
                                transition={{
                                delay: 0.4,
                                default: { ease: "linear" },
                            }}>
                        <div className="col-4">
                            <img className="subpic dis" src="./cpaImg/reg_pic.jpg" alt=""/>
                        </div>
                    </motion.div>
                    <div className="col-8">
                        <div className="fs-1 mb-3">Auditing and Attestation 審計與鑑證 (簡稱 AUD)</div>
                        <div className="mb100">在審計基本觀念及方法上，台灣與美國大致相同， 惟在相關法令規定上差異較大。尤其在2001 年安隆（Enron）案發生後，相關審計規定不斷更新，沙賓法案（Sarbanes-Oxley Act）通過及 PCAOB 設立，對於審計專業人員之影響甚大。

                        本科目為必考學科 (core exam)，學習範圍主要包含審計服務、簽證服務、會計及核閱服務等，其中包含應用資訊科技概念、數據分析技術進行風險評估與完成規劃程序，並以專業判斷審慎評估查核證據，採用抽樣方式覆核原始憑證，用以辨認問題、分析事實及規劃適當查核程序。

                        針對此學科，Becker 以完整的內容美國審計應用與規定，對於考生未來在大型會計師事務所或在跨國集團擔任財會主管時，將有極大之助益。
                        </div>
                        <ul>
                            <li className="tsti">
                                <span className="tmxl">出題範圍</span>
                                <span className="tmm">題型配比</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area I</span>
                                <span className="tml">Ethics, Professional Responsibilities and General Principles</span>
                                <span className="tmm">職業道德、會計師專業責任與一般原則</span>
                                <span className="tmm">15-25%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area II</span>
                                <span className="tml">Assessing Risk and Developing a Planned Response</span>
                                <span className="tmm">評估風險與制訂應對計畫</span>
                                <span className="tmm">25-35%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area III</span>
                                <span className="tml">Performing Further Procedures and Obtaining Evidence</span>
                                <span className="tmm">執行查核程序與取得查核證據</span>
                                <span className="tmm">30-40%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area IV</span>
                                <span className="tml">Forming Conclusions and Reporting</span>
                                <span className="tmm">完成結論與查核報告</span>
                                <span className="tmm">10-20%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area V</span>
                                <span className="tml">Federal Taxation of Entities</span>
                                <span className="tmm">公司稅</span>
                                <span className="tmm">28-38%</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="d-flex subjecttable mb100">
                    <motion.div
                                initial={{ opacity: 0, x:-100 }}
                                whileInView={{ opacity: 1, x:0 }}
                                transition={{
                                delay: 0.4,
                                default: { ease: "linear" },
                            }}>
                        <div className="col-4">
                            <img className="subpic dis" src="./cpaImg/aud_pic.jpg" alt=""/>
                        </div>
                    </motion.div>
                    <div className="col-8">
                        <div className="fs-1 mb-3">Taxation and Regulation 稅務與法規 (簡稱 REG)</div>
                        <div className="mb100">對非美籍的華人考生而言，求學過程中甚少涉獵英美法，因此 REG 向來是相對陌生的科目；但毋須擔憂：根據歷年 NASBA Candidate Performance Book（付費數據報告書）台灣考生平均通過分數為亞洲第二、僅比中國大陸低 0.1 分，絕大多數皆在沒有修過美國商法稅法學分的情況之下，順利通過 REG 考試。
                        本科目學習範圍包含 ── 美國聯邦稅法、定期性或一次性個人與企業稅務處理、商事法等；美國商事法及稅法體系複雜且龐大，著重對美國文化思考脈絡的理解推導、和對法規架構的熟悉。Becker 教材美師影片、與中文課程講師皆持美國律師資格專業背景、法律事務所實務經驗，深入淺出解說全新的 REG 考科，幫助非美籍的華人考生快速理解、適應新制考試。
                        </div>
                        <ul>
                            <li className="tsti">
                                <span className="tmxl">出題範圍</span>
                                <span className="tmm">題型配比</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area I</span>
                                <span className="tml">Ethics, Professional Responsibilities and Federal Tax Procedures</span>
                                <span className="tmm">聯邦稅法、道德專業與法律責任</span>
                                <span className="tmm">10–20%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area II</span>
                                <span className="tml">Business Law</span>
                                <span className="tmm">商事法</span>
                                <span className="tmm">15–25%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area III</span>
                                <span className="tml">Federal Taxation of Property Transactions</span>
                                <span className="tmm">聯邦稅 - 產權交易</span>
                                <span className="tmm">5–15%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area IV</span>
                                <span className="tml">Federal Taxation of Individuals</span>
                                <span className="tmm">聯邦稅 - 個人稅</span>
                                <span className="tmm">22–32%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area V</span>
                                <span className="tml">Federal Taxation of Entities (including tax preparation)</span>
                                <span className="tmm">聯邦稅 - 公司稅 (含稅務申報)</span>
                                <span className="tmm">23–33%</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="detexct">
                        以下三科是專科考試 (discipline exams)，每個考生需選擇其中一科通過考試（也僅能通過其中一科）。
                        Becker Taiwan 學員可透過閱讀教材軟體、或預約諮詢，依照個人學習背景、讀書狀況等，決定選擇哪一門專科考試、如何安排科目順序。
                    </div>
                <div className="d-flex subjecttable mb100 mt100">
                    <motion.div
                                initial={{ opacity: 0, x:-100 }}
                                whileInView={{ opacity: 1, x:0 }}
                                transition={{
                                delay: 0.4,
                                default: { ease: "linear" },
                            }}>
                        <div className="col-4 dis">
                            <img className="subpic" src="./cpaImg/far_pic.jpg" alt=""/>
                        </div>
                    </motion.div>
                    <div className="col-8">
                        <div className="fs-1 mb-3">
                            Business Analysis and Reporting 商業分析與報告 (簡稱 BAR)
                        </div>
                        <div className="mb100">
                            BAR (商業分析) 可說是進階版本的 FAR (財務會計)，兩者關聯性最高；BAR 中的高級會計學、成本與管理會計學、財務分析等考試內容，皆建立在 FAR 中學習過的概念上。
                            對於會計本科系考生而言， BAR 是三門專科 (discipline exam) 中能較快適應的一科，因此多數選擇此專科應考；在準備 FAR 科目後面銜接繼續準備 BAR，將有內容連貫、學習效率加乘的效果。

                            準備 BAR 考試，將幫助您習得以下技能和專長：
                            <div className="barli">
                                <ul>
                                    <li>資料分析</li>
                                    <li>財務風險管理、規劃</li>
                                    <li>複雜的會計處理</li>
                                    <li>州政府、地方政府會計</li>
                                </ul>
                            </div>
                            準備 BAR 過程中學習到的技能，適合以下職涯發展：
                            <div className="barli">
                                <ul>
                                    <li>審計員</li>
                                    <li>在企業的會計部門工作</li>
                                    <li>財務總監 (controller)</li>
                                    <li>主辦會計</li>
                                    <li>CFO 或 CEO</li>
                                </ul>
                            </div>
                            Becker 的 BAR 課程由業界經歷豐富的講師教授，有效幫助考生理解複雜度與實用性兼具的專業科目，學習精準解題和得分、同時累積相同重要的實務應用技巧，幫助未來在工作上能快速理解問題與勝任。
                        </div>
                        <ul>
                            <li className="tsti">
                                <span className="tmxl">出題範圍</span>
                                <span className="tmm">題型配比</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area I</span>
                                <span className="tml">Business Analysis</span>
                                <span className="tmm">商業分析</span>
                                <span className="tmm">40-50%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area II</span>
                                <span className="tml">Technical Accounting and Reporting</span>
                                <span className="tmm">較複雜的會計與報告</span>
                                <span className="tmm">35-45%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area III</span>
                                <span className="tml">State and Local Governments</span>
                                <span className="tmm">州政府與當地政府會計</span>
                                <span className="tmm">10-20%</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="d-flex subjecttable mb100">
                    <motion.div
                                initial={{ opacity: 0, x:-100 }}
                                whileInView={{ opacity: 1, x:0 }}
                                transition={{
                                delay: 0.4,
                                default: { ease: "linear" },
                            }}>
                        <div className="col-4">
                            <img className="subpic dis" src="./cpaImg/reg_pic.jpg" alt=""/>
                        </div>
                    </motion.div>
                    <div className="col-8">
                        <div className="fs-1 mb-3">Information Systems and Controls 資訊系統與控制 (簡稱 ISC)</div>
                        <div className="mb100">
                            <div className="tmbk">
                            ISC 是三選一專科 (discipline exams) 之中最資訊科技份量最多的，適合修過基礎資訊系統學分、或擁有相關工作經驗的考生選擇；根據 AICPA 發布的2024新制考試藍圖報告顯示，相較於會計系背景者選考 BAR 時需應付的出題範圍難度，ISC 對於「有資訊背景者」會是絕對容易上手、應考的一科。

                            若您具有以下幾項知識能力，ISC 極可能是最適合您的一科：
                            <div className="barli">
                                <ul>
                                    <li>資料管理</li>
                                    <li>資訊系統</li>
                                    <li>資訊安全</li>
                                    <li>商業流程模型</li>
                                    <li>系統與組織控制</li>
                                </ul>
                            </div>
                            準備 ISC 這一科時獲取的知識技能，能裝備自己、往以下職涯發展：
                            <div className="barli">
                                <ul>
                                    <li>資料管理 (數據經理)</li>
                                    <li>數據工程師/資料科學家</li>
                                    <li>CIO 或 CTO</li>
                                    <li>電腦審計員</li>
                                </ul>
                            </div>
                            現今的會計與審計是離不開資訊科技的。Becker 的 ISC 課程由持資訊與會計雙重專業背景、實務經歷豐富的講師授課，幫助各位考生、無論原本是否具備資訊科技相關的專業知識，都能快速理解重要術語和思維架構，同時增加許多職場上非常實用的技能，相較於缺乏資訊科技專業素養者有更多的優勢。
                            </div>
                        </div>
                        <ul>
                            <li className="tsti">
                                <span className="tmxl">出題範圍</span>
                                <span className="tmm">題型配比</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area I</span>
                                <span className="tml">Information Systems and Data Management</span>
                                <span className="tmm">資訊系統與資料管理</span>
                                <span className="tmm">35-45%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area II</span>
                                <span className="tml">Security, Confidentiality and Privacy</span>
                                <span className="tmm">資訊安全、保密與隱私</span>
                                <span className="tmm">35-45%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area III</span>
                                <span className="tml">Considerations for System and Organization Controls (SOC) Engagements</span>
                                <span className="tmm">系統與組織控制委任案件的考量</span>
                                <span className="tmm">15-25%</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="d-flex subjecttable mb100">
                    <motion.div
                                initial={{ opacity: 0, x:-100 }}
                                whileInView={{ opacity: 1, x:0 }}
                                transition={{
                                delay: 0.4,
                                default: { ease: "linear" },
                            }}>
                        <div className="col-4">
                            <img className="subpic dis" src="./cpaImg/aud_pic.jpg" alt=""/>
                        </div>
                    </motion.div>
                    <div className="col-8">
                        <div className="fs-1 mb-3">Tax Compliance and Planning 稅務遵循與規劃 (簡稱 TCP)</div>
                        <div className="mb100">
                        <div className="tmbk">
                            在所有三選一專科 (discipline exams) 之中，TCP 這一科與 REG (稅務與法規）高度相關、可視為 REG 的進階考科，適合會計與財稅科系背景、或持相關經驗者選考。考生可在準備 REG 科目後面銜接繼續準備 TCP，將有內容連貫、提高記憶速度的效果。

                            準備 TCP 考試，將幫助您習得以下技能和專長：
                            <div className="barli">
                                <ul>
                                    <li>進階個人稅務遵循</li>
                                    <li>個人稅務 (投資、IRS、401k、退休等）規劃</li>
                                    <li>進階企業稅務遵循與規劃</li>
                                    <li>產權交易</li>
                                </ul>
                            </div>
                            準備 TCP 過程中學習到的技能，適合以下職涯發展：
                            <div className="barli">
                                <ul>
                                    <li>稅務分析師</li>
                                    <li>稅務遵循專員</li>
                                    <li>在企業、會計師事務所、政府單位、銀行、或避險基金的稅務部門工作</li>
                                    <li>經營個人稅務實業</li>
                                </ul>
                            </div>
                            Becker 的 TCP 課程由持有美國法律博士、美國律師資格、同時具備法遵實務經歷豐富的講師授課，幫助考生迅速理解法律用語和美國稅制架構，適合以美稅專長為職涯目標的考生。
                            </div>
                        </div>
                        <ul>
                            <li className="tsti">
                                <span className="tmxl">出題範圍</span>
                                <span className="tmm">題型配比</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area I</span>
                                <span className="tml">Tax Compliance and Planning for Individuals and Personal Financial Planning</span>
                                <span className="tmm">個人稅務遵循與規劃、財務規劃</span>
                                <span className="tmm">30-40%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area II</span>
                                <span className="tml">Entity Tax Compliance</span>
                                <span className="tmm">企業稅務遵循</span>
                                <span className="tmm">30-40%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area III</span>
                                <span className="tml">Entity Tax Planning</span>
                                <span className="tmm">企業稅務規劃</span>
                                <span className="tmm">10-20%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area IV</span>
                                <span className="tml">Federal Taxation of Individuals</span>
                                <span className="tmm">聯邦稅 - 個人稅</span>
                                <span className="tmm">22–32%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area V</span>
                                <span className="tml">Property Transactions (disposition of assets)</span>
                                <span className="tmm">產權交易 (資產處置)</span>
                                <span className="tmm">10-20%</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="br mb100 mt100"></div>
            </div>
            {/* <!-- 考試時間與成績保留原則 --> */}
            <div className="container examtimeline mt100 mb100 dis">
                <div className="beckertitlename mb100" id="examtimeline">考試時間與成績保留原則</div>
                <ul className="base-timeline mb100 mt100 m-auto">
                    <li className="base-timeline__item base-timeline__item--data"data-step="STEP 1">
                        <span className="base-timeline__summary-text " 
                        >學歷認證</span>
                    </li>
                    <li className="base-timeline__item base-timeline__item base-timeline__item--data"data-step="STEP 2">
                        <span className="base-timeline__summary-text" 
                        >取得NTS</span>
                    </li>
                    <li className="base-timeline__item base-timeline__item--data"data-step="STEP 3">
                        <span className="base-timeline__summary-text " 
                        >正式考試</span>
                    </li>
                </ul>
            </div>
            <div className="container stepinfo">
                <div className="fs-3 mb-4 ">申請考試</div>
                <ul>
                    <li>Step1：完成學歷認證( 時間約需2周至2個月不等)。</li>
                    <li>Step2：報名平台的驗證，作業時間約需要6-8周不等。</li>
                    <li>Step3：接續取得NTS，以進行後續預約考場的動作。 (NTS的效期為6個月)</li>
                </ul>
                <div className="fs-3 mb-4 mt-5">預約考場</div>
                <ul>
                    <li>每週一至週五皆開放預約考試，早上、下午各一個考試時段。</li>
                    <li>考試地點不限於考生報考的身分州，例如：以關島資格報考之考生，可以選擇於 LA 的考場應考。</li>
                    <li>2020年七月起，取消每季不得重複應考之限制；考後收到成績不及格通知時，可立即再次報考該科。</li>
                    <li>所有考科不限一次考完，各次應考科數可依個人規劃申請應試。</li>
                </ul>
                <div className="fs-3 mb-4 mt-5">考試及格成績：75分，單科成績保留30個月</div>
                <ul>
                    <li>通過第一科考試後，30 個月內須通過其他3科考試，目前多州調整為30個月，即須在30個月內完成4科考試；若超過30個月完成4科考試 ，則須重新應考成績失效的科目。</li>
                </ul>
                <div className="br mb100 mt100"></div>
            </div>
            <div className="container">
                <div className="beckertitlename mb100" id="eligibility">應考步驟與報考資格</div>
                <div className="d-flex justify-content-around mb100">
                    <motion.div
                                initial={{ opacity: 0, y:-100 }}
                                whileInView={{ opacity: 1, y:0 }}
                                transition={{
                                delay: 0.3,
                                default: { ease: "linear" },
                            }}>
                        <div className="stepcircle bc dis">Step 1<br/>選州</div>
                    </motion.div>
                    <motion.div
                                initial={{ opacity: 0, y:-100 }}
                                whileInView={{ opacity: 1, y:0 }}
                                transition={{
                                delay: 0.4,
                                default: { ease: "linear" },
                            }}>
                        <div className="stepcircle fr dis">Step 2<br/>學歷認證</div>
                    </motion.div>
                    <motion.div
                                initial={{ opacity: 0, y:-100 }}
                                whileInView={{ opacity: 1, y:0 }}
                                transition={{
                                delay: 0.5,
                                default: { ease: "linear" },
                            }}>
                        <div className="stepcircle rg dis">Step 3<br/>考試申請</div>
                    </motion.div>
                    <motion.div
                                initial={{ opacity: 0, y:-100 }}
                                whileInView={{ opacity: 1, y:0 }}
                                transition={{
                                delay: 0.6,
                                default: { ease: "linear" },
                            }}>
                        <div className="stepcircle au dis">Step 4<br/>准考通知</div>
                    </motion.div>
                    <motion.div
                                initial={{ opacity: 0, y:-100 }}
                                whileInView={{ opacity: 1, y:0 }}
                                transition={{
                                delay: 0.7,
                                default: { ease: "linear" },
                            }}>
                        <div className="stepcircle mau dis">Step 5<br/>考前叮嚀</div>
                    </motion.div>
                </div>
                <div className="fs-2 mb100 text-center dis">申請門檻</div>
                <div className="text-center w-75 m-auto">美國會計師考試資格依所報考州別不同，而有不同的資格限制，其通過後申請執照要求也各不相同，報考前可依「報考目的」、「執業需求」與「現有學分數」評估州別選擇。建議如要一一研究，至NASBA 網站會是首要步驟。以下表格就華盛頓、緬因、新罕布夏州與關島地區為例，篩選出總學分數、學位資格、會計與商業學分，與取得執照等註：最新最正確的學分要求與取照規定請上NASBA</div>
                <ul className="tsbox">
                    <li className="tsti">
                        <span>　</span>
                        <span>WA</span>
                        <span>ME</span>
                        <span>NH</span>
                        <span>GU</span>
                    </li>
                    <li className="wt">
                        <span>總學分數</span>
                        <span>120</span>
                        <span>150</span>
                        <span>120</span>
                        <span>120</span>
                    </li>
                    <li className="gr">
                        <span>學士學歷</span>
                        <span>YES</span>
                        <span>YES</span>
                        <span>YES</span>
                        <span>YES</span>
                    </li>
                    <li className="wt">
                        <span>會計/商業學分</span>
                        <span>24/24</span>
                        <span>15/0</span>
                        <span>30/24<br/><p>(After 7/1/2014)</p></span>
                        <span>24/24<br/><p>可先報考，於第一次赴考後18個月內補足(註1)</p></span>
                    </li>
                    <li className="gr">
                        <span>畢業後應考</span>
                        <span>NO</span>
                        <span>NO/120 days</span>
                        <span>NO</span>
                        <span>YES/18 months</span>
                    </li>
                    <li className="wt">
                        <span>執照總學分需求</span>
                        <span>120</span>
                        <span>150</span>
                        {/* style="font-size: 0.5em" */}
                        <span>120<br/><p>(Before 7/1/2014)</p></span>
                        <span>150<br/></span>
                    </li>
                    <li className="gr">
                        <span>執照工作經驗需求</span>
                        <span>1 year</span>
                        <span>2 years</span>
                        <span>1 year</span>
                        <span>1 year</span>
                    </li>
                </ul>
                註：各州相關規定可能隨時異動，請依 NASBA 官方公告為準。
                <div className="br mb100"></div>
            </div>
            <div className="container-fluid">
                <div className="beckertitlename mb100" id="eligibility">考試花費成本</div>
                
            </div>
            <div className="container">
                <div className="ue_bk">
                    美國會計師考試規費依所報考州別有所不同，實際應考地點也依各區域酌收不同的考場費，<br/>

                    以下表格就華人最常選擇之關島考生身分、加上赴美國本土應考為例，列舉考取美國註冊會計師考試必需花費項目：<br/><br/>

                    <div className="text-muted">註：金額數字請依官方考試單位 NASBA 網站更新顯示為準。</div>
                </div>
                <table className="table table-bordered mt-2">
                    <thead className="table-dark">
                        <tr>
                        <th scope="col">流程階段</th>
                        <th scope="col">費用項目</th>
                        <th scope="col">費用金額</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>學歷認證</th>
                            <td>FACS</td>
                            <td>$349.00（Becker 台灣學員另享專屬優惠 $231.00）</td>
                        </tr>
                        <tr>
                            <th rowspan="2">報名考試</th>
                            <td>關島 (NASBA) 首次報考審核費 Education Evaluation Application</td>
                            <td>$136.00</td>
                        </tr>
                        <tr>
                            <td>關島 (NASBA) 考科單科*4 Exam Section Application Fee</td>
                            <td>$1,514.56</td>
                        </tr>
                        <tr>
                            <th>考場費</th>
                            <td>美國本土應考，無需支付考場費</td>
                            <td>$0.00</td>
                        </tr>
                        <tr>
                            <td className="" colspan="2"><small>小計 (美金)</small></td>
                            <td>$1,881.56</td>
                        </tr>
                        <tr>
                            <td colspan="2"><small>小計 (換算台幣)</small></td>
                            <td>NT$60,167.00</td>
                        </tr>
                        <tr>
                            <td colspan="3" className=""></td>
                        </tr>
                        <tr>
                            <th>出國考試</th>
                            <td>以美國舊金山地區為例，8天7夜來回機票+飯店住宿</td>
                            <td>NT$53,679.00</td>
                        </tr>
                        <tr>
                            <th>教材</th>
                            <td>Becker 全修方案</td>
                            <td>NT$113,000</td>
                        </tr>
                        <tr>
                            <th colspan="2">花費總額 (台幣)</th>
                            <td>NT$226,846.00</td>
                        </tr>
                    </tbody>
                </table>
                <div className="text-right costt mb100">製表：2026年3月</div>
            </div>
            
            <div className="container">
                <div className="br mb100"></div>
                <div className="fs-2 mb-3 text-center fw-bold">雙照計劃</div>
                <div className="text-center mb100">USCPA VS. ROCCPA<br/>領有外國會計師證書，經考選部認可者，得申請部分科目免試</div>
                <div className="d-flex w-75 douicon">
                    <div className="col-6 text-center">
                        <img className="m-auto" src="./cpaImg/dou_icon2.svg"alt=""/>
                        <div className="fw-bold mt-3">抵免科目<br/>中會、高會、成會、國文</div>
                    </div>
                    <div className="col-6 text-center">
                        
                        <img className="m-auto" src="./cpaImg/dou_icon.svg"alt=""/>
                    <div className="fw-bold mt-3">必考科目<br/>審計、稅法、公司法<br/>&<br/>證券交易法&商業會計法</div>
                    </div>
                </div>
                <div className="fs-2 mb-3 text-center fw-bold">通過USCPA考試後</div>
                <div className="text-center w-75 m-auto mt-5 mb-5">
                    需向所屬州別申請 USCPA 執照於隔年3月向考選部提出台灣會計師考試抵免申請，5月報考8月份台灣會計師專技考試若「台灣會計師3科考試」與「抵免申請」兩件事相繼於三年內完成（無先後順序），即可取得台灣會計師執照，拿取台美雙照頭銜。
                </div>
                <div className="br mt100 mb100"></div>
                
                <div className="m-auto w-100">
                    {/* <!-- 證照互認協議 --> */}
                    <div className="fs-2 mb-3 text-center fw-bold" id="protocol">證照互認協議</div>
                    <div className="protocol mt100 mb100">
                        <img className="m-auto" src="./cpaImg/protocol.jpg"alt=""/>
                        <div className="fs-2 mt-3 mb-3 text-center fw-bold" id="protocol2">相互承認協議</div>
                        <div className="w-50 text-center m-auto">NASBA / AICPA國際資格鑑定委員會（IQAB）是美國會計專業與其他“服務貿易總協定”（GATS）簽署國之間的聯繫。通過相互承認協議（MRA），來自另一個國家的合格專業會計師可以在美國執業，而無需完全重新認證，同樣承認希望在同一個國家執業的美國註冊會計師。</div>
                        <img className="mt100 m-auto" src="./cpaImg/teacher_banner.jpg"alt=""/>
                        <div className="fs-2 mt-3 mb-3 text-center fw-bold">當前協議</div>
                        <div className="w-50 text-center m-auto">IQAB目前已經與以下專業機構建立了MRA</div>
                    </div>
                </div>
                <div className="container-fluid mb100">
                    <div className="row">
                        <div className="col-sm-3 ctbox ctl">
                        <div className="ct-content">
                            <img src="./cpaImg/ic_ct01.png" alt="澳洲特許會計師協會(ICAA)" />
                            <p>澳洲特許會計師協會(ICAA)</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox">
                        <div className="ct-content">
                            <img src="./cpaImg/ic_ct02.png" alt="CPA Canada (CPAC)" />
                            <p>CPA Canada (CPAC)</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox">
                        <div className="ct-content">
                            <img src="./cpaImg/ic_ct03.png" alt="蘇格蘭特許會計師協會(ICAS)" />
                            <p>蘇格蘭特許會計師協會(ICAS)</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox">
                        <div className="ct-content">
                            <img src="./cpaImg/ic_ct04.png" alt="愛爾蘭特許會計師公會(CAI)" />
                            <p>愛爾蘭特許會計師公會(CAI)</p>
                        </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-4 ctbox ctl">
                        <div className="ct-content">
                            <img src="./cpaImg/ic_ct05.png" alt="墨西哥公共會計師公會(IMCP)" />
                            <p>墨西哥公共會計師公會(IMCP)</p>
                        </div>
                        </div>
                        <div className="col-sm-4 ctbox">
                        <div className="ct-content">
                            <img src="./cpaImg/ic_ct06.png" alt="紐西蘭特許會計師協會(NZICA)" />
                            <p>紐西蘭特許會計師協會(NZICA)</p>
                        </div>
                        </div>
                        
                    </div>
                    </div>
                    <div className="br mt100 mb100"></div>
                    <div className="beckertitlename mt100 mb-5" id="com">美國註冊會計師教材產品
                    與坊間方案比較表</div>
                    <div className="compare wcompare">
                        <table className="text-center">
                            <tr>
                                <td className="col-2">
                                    <div className="a1">產品功能</div>
                                </td>
                                <td className="col-2">
                                    <div className="a2">坊間</div>
                                </td>
                                <td className="col-3">
                                    <div className="a3">捷進 Becker</div>
                                </td>
                                <td className="col-3">
                                    <div className="a3">考生見證</div>
                                </td>
                                <td className="col-2">
                                    <div className="a3">見證全文</div>
                                </td>
                            </tr>
                            <tr className="">
                                <td className="a4 formt" align="center" valign="top">
                                    <div>通過率</div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div>N/A</div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div className="win_c">
                                        <img src="./serviceImg/win.png" className="win" alt="win"/>
                                    </div>
                                    <div>連續16年屢創95%高分通過獎Watt Sells Award 冠軍</div>
                                </td>
                                <td className="a4" align="left">
                                    <div>「傳說中的 Becker Bump 是真的存在，我的最後考試成績都比Becker 的模擬考多了20~30分。只要拿 Becker 教材來練習，假以時日，堅持到底，考取美國會計師真的不難。」<br/>
                                            —— Leon，2023年9月通過全科考試</div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div><a href="https://beckertw.com/art/561">獲獎佳績</a></div>
                                </td>
                            </tr>
                            <tr className="">
                                <td className="a5 formt" align="center" valign="top">
                                    <div>教材與真實考試相似度</div>
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div>N/A</div>
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div className="win_c">
                                        <img src="./serviceImg/win.png" className="win2" alt="win"/>
                                    </div>
                                    <div>由退休 U.S. CPA 考官組成研發團隊，模擬實際考試相似度近100%</div>
                                </td>
                                <td className="a5" align="left" valign="top" >
                                        「經過體驗教材 Becker，介面很容易上手，內容簡潔並且很多實用的重點整理，加上模擬試題介面與實際考試的介面相似，因此讓我在實際考試時更上手也更輕鬆。」
                                            <br/>—— Cherry，2023年6月通過全科考試<br/><br/>
                                    「我覺得Becker的題庫是真的跟實戰的時候很像，所以一定要認真檢討作題結果。」<br/>—— 薇薇安，2023年3月通過全科考試
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div><a href="https://beckertw.com/art/517">Cherry</a><br/><br/><br/><br/><br/><a href="https://beckertw.com/art/494">薇薇安</a></div>
                                </td>
                            </tr>
                            <tr className="">
                                <td className="a4 formt" align="center" valign="top">
                                    <div>師資</div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div>1人教四科</div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div className="win_c">
                                        <img src="./serviceImg/win.png" className="win3" alt="win"/>
                                    </div>
                                    <div>各科由持該領域專業的10位中美講師聯合執教</div>
                                </td>
                                <td className="a4" align="left">
                                    <div>「面授課程的收穫完全超乎我的期待，REG的律師老師幫助我釐清許多自己讀書時認知錯誤的概念，讓我 REG 有清楚架構而不是支離破碎東拼西湊的記憶，老師課後還耐心為同學解惑，真的很感謝老師。」
                                        <br/>—— Mia，東吳大學會計系應屆畢業生<br/><br/>
                                        「選擇法規與審計這兩科不再一集一集聽外師上課，決定上中文數位課程把這兩科加速讀完，事後證明，經由中師的講解，理解速度快了不少，同時上完中師的課，就直接寫一半的題目，答對率也十分不錯」
                                        <br/>—— Wogan Chang，2023年9月通過考試</div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div><a href="https://beckertw.com/art/269">Mia</a><br/><br/><br/><br/><br/><br/><a href="https://beckertw.com/art/552">Wogan</a></div>
                                </td>
                            </tr>
                            <tr className="">
                                <td className="a5 formt" align="center" valign="top">
                                    <div>考試解題服務</div>
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div>1人電郵回答</div>
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div className="win_c">
                                        <img src="./serviceImg/win.png" className="win4" alt="win"/>
                                    </div>
                                    <div>1.Academic Support 美籍外師<br/>
                                        48小時內線上解答<br/>
                                        2.共5位中文老師老師不限次數回答<br/>
                                        3.近10年累積考題解答知識庫，<br/>
                                        關鍵字查詢任意歷史問答 Q&A
                                    </div>
                                </td>
                                <td className="a5" align="left" valign="top" >
                                    「非常推薦中文線上解題服務，能進行發問，也能在系統上看到過去考生與老師問答的過程，答覆都十分用心，這部分讓我獲益良多。」
                                    <br/>—— 林昱仁 ，2023年9月通過全科考試
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div><a href="https://beckertw.com/art/556">林昱仁</a></div>
                                </td>
                            </tr>
                            <tr className="">
                                <td className="a4 formt" align="center" valign="top">
                                    <div>流程諮詢服務<br/>
                                        <span>*皆針對購買中文全科者</span>
                                    </div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div>1個月1次<br/>
                                        每次30分鐘<br/>
                                        (限周末)
                                    </div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div className="win_c">
                                        <img src="./serviceImg/win.png" className="win5" alt="win"/>
                                    </div>
                                    <div>不限次數，一週六天<br/>
                                        即時文字或通話諮詢
                                    </div>
                                </td>
                                <td className="a4" align="left">
                                    <div>「相信考過美會的人一定能切身體會壓力來源不單單只是考試本身，還有繁瑣的報考流程、擔心申請文件出差錯等等，謝謝Becker 耐心協助我與美國會計師協會、學歷認證機構聯絡，並提供我以前學員遇過的問題並告訴我最佳路徑，省去我走錯路的時間及金錢。」
                                        <br/>—— 周同學，2023年3月通過全科考試
                                    </div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div><a href="https://beckertw.com/art/538">周同學</a></div>
                                </td>
                            </tr>
                            <tr className="">
                                <td className="a5 formt" align="center" valign="top">
                                    <div>方案永續性</div>
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div>18個月即中止</div>
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div className="win_c">
                                        <img src="./serviceImg/win.png" className="win6" alt="win"/>
                                    </div>
                                    <div>至少24個月，且得免費延長<br/>至通過考試為止<br/>跟著 AICPA 公告即時更新教材
                                    </div>
                                </td>
                                <td className="a5" align="left" valign="top" >
                                    「完成報名及資格審核，卻因疫情及工作影響遲遲未能投入時間準備，考試及唸書計畫也一延再延... 謝謝 Becker 讓我不需要額外付費，畢竟離報名課程已超過兩年。」
                                    <br/>—— Ryan，2023年9月通過全科考試
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div><a href="https://beckertw.com/art/535">Ryan</a></div>
                                </td>
                            </tr>
                            <tr className="">
                                <td className="a4 formt" align="center" valign="top">
                                    <div>完備性<br/>
                                    </div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div>目前僅3科
                                    </div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div className="win_c">
                                        <img src="./serviceImg/win.png" className="win7" alt="win"/>
                                    </div>
                                    <div>
                                        斥資百萬美元研發全6科已上架上線
                                    </div>
                                </td>
                                <td className="a4" align="left">
                                    <div>「Becker 有長期輔導經驗，學程內容跟著考情更新 (更新資料頻率高，尤其更新項目一定要熟讀，就是考點！)，能有效率的成功通關。」
                                    <br/>—— Barry Hsieh，2023年11月通過考試
                                    </div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div><a href="https://beckertw.com/art/570">Barry Hsieh</a></div>
                                </td>
                            </tr>
                        </table>
                        <div className="text-left">以上見證文章與人名，皆獲學員本人授權公開刊登</div>
                        <div className="safe">
                            <img className="cheack"  src="./serviceImg/com_image_005.png" alt="com"/>
                            <div className="title2">
                                降低重考風險，Becker CPA 最保險
                            </div>
                            <div className="sub">
                                使用 Becker 達到 94% 考試通過率！ <a href="https://beckertw.com/art/326">(什麼是 Becker Bump?)</a>
                            </div>
                        </div>
                    </div>
                    <div className="row mcompare">
                        <div className="compare">
                            <table className="text-center">
                                <tr>
                                    <td nowrap="">
                                        <div className="a1">產品功能</div>
                                    </td>
                                    <td nowrap="">
                                        <div className="a2">坊間</div>
                                    </td>
                                    <td nowrap="">
                                        <div className="a3">捷進 Becker</div>
                                    </td>
                                    <td nowrap="">
                                        <div className="a3">考生見證</div>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className="a4 formt" align="center" valign="top">
                                        <div>通過率</div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div>N/A</div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div className="win_c">
                                            <img src="./serviceImg/win.png" className="win" alt="win"/>
                                        </div>
                                        <div>連續16年屢創95%高分通過獎Watt Sells Award 冠軍</div>
                                    </td>
                                    <td className="a4" align="left">
                                        <div>「傳說中的 Becker Bump 是真的存在，我的最後考試成績都比Becker 的模擬考多了20~30分。只要拿 Becker 教材來練習，假以時日，堅持到底，考取美國會計師真的不難。」<br/>
                                                —— 2023年9月通過全科考試<a className="text-danger text-decoration-underline" href="https://beckertw.com/art/561">Leon</a></div>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className="a5 formt" align="center" valign="top">
                                        <div>教材與真實考試相似度</div>
                                    </td>
                                    <td className="a5" align="center" valign="top">
                                        <div>N/A</div>
                                    </td>
                                    <td className="a5" align="center" valign="top">
                                        <div className="win_c">
                                            <img src="./serviceImg/win.png" className="win2" alt="win"/>
                                        </div>
                                        <div>由退休 U.S. CPA 考官組成研發團隊，模擬實際考試相似度近100%</div>
                                    </td>
                                    <td className="a5" align="left" valign="top" >
                                            「經過體驗教材 Becker，介面很容易上手，內容簡潔並且很多實用的重點整理，加上模擬試題介面與實際考試的介面相似，因此讓我在實際考試時更上手也更輕鬆。」
                                                <br/>—— 2023年6月通過全科考試<a className="text-danger text-decoration-underline" href="https://beckertw.com/art/517">Cherry</a><br/><br/>
                                        「我覺得Becker的題庫是真的跟實戰的時候很像，所以一定要認真檢討作題結果。」<br/>—— 2023年3月通過全科考試
                                        <a className="text-danger text-decoration-underline" href="https://beckertw.com/art/494">薇薇安</a>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className="a4 formt" align="center" valign="top">
                                        <div>師資</div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div>1人教四科</div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div className="win_c">
                                            <img src="./serviceImg/win.png" className="win3" alt="win"/>
                                        </div>
                                        <div>各科由持該領域專業的10位中美講師聯合執教</div>
                                    </td>
                                    <td className="a4" align="left">
                                        <div>「面授課程的收穫完全超乎我的期待，REG的律師老師幫助我釐清許多自己讀書時認知錯誤的概念，讓我 REG 有清楚架構而不是支離破碎東拼西湊的記憶，老師課後還耐心為同學解惑，真的很感謝老師。」
                                            <br/>—— 東吳大學會計系應屆畢業生<a className="text-danger text-decoration-underline" href="https://beckertw.com/art/269">Mia</a><br/><br/>
                                            「選擇法規與審計這兩科不再一集一集聽外師上課，決定上中文數位課程把這兩科加速讀完，事後證明，經由中師的講解，理解速度快了不少，同時上完中師的課，就直接寫一半的題目，答對率也十分不錯」
                                            <br/>—— 2023年9月通過考試<a className="text-danger text-decoration-underline" href="https://beckertw.com/art/552">Wogan</a></div>

                                    </td>
                                    <td className="a4" align="center" valign="top">
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className="a5 formt" align="center" valign="top">
                                        <div>考試解題服務</div>
                                    </td>
                                    <td className="a5" align="center" valign="top">
                                        <div>1人電郵回答</div>
                                    </td>
                                    <td className="a5" align="center" valign="top">
                                        <div className="win_c">
                                            <img src="./serviceImg/win.png" className="win4" alt="win"/>
                                        </div>
                                        <div>1.Academic Support 美籍外師<br/>
                                            48小時內線上解答<br/>
                                            2.共5位中文老師老師不限次數回答<br/>
                                            3.近10年累積考題解答知識庫，<br/>
                                            關鍵字查詢任意歷史問答 Q&A
                                        </div>
                                    </td>
                                    <td className="a5" align="left" valign="top" >
                                        「非常推薦中文線上解題服務，能進行發問，也能在系統上看到過去考生與老師問答的過程，答覆都十分用心，這部分讓我獲益良多。」
                                        <br/>—— 2023年9月通過全科考試
                                        <a className="text-danger text-decoration-underline" href="https://beckertw.com/art/556">林昱仁</a>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className="a4 formt" align="center" valign="top">
                                        <div>流程諮詢服務<br/>
                                            <span>*皆針對購買中文全科者</span>
                                        </div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div>1個月1次<br/>
                                            每次30分鐘<br/>
                                            (限周末)
                                        </div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div className="win_c">
                                            <img src="./serviceImg/win.png" className="win5" alt="win"/>
                                        </div>
                                        <div>不限次數，一週六天<br/>
                                            即時文字或通話諮詢
                                        </div>
                                    </td>
                                    <td className="a4" align="left">
                                        <div>「相信考過美會的人一定能切身體會壓力來源不單單只是考試本身，還有繁瑣的報考流程、擔心申請文件出差錯等等，謝謝Becker 耐心協助我與美國會計師協會、學歷認證機構聯絡，並提供我以前學員遇過的問題並告訴我最佳路徑，省去我走錯路的時間及金錢。」
                                            <br/>—— 2023年3月通過全科考試
                                        <a className="text-danger text-decoration-underline" href="https://beckertw.com/art/538">周同學</a></div>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className="a5 formt" align="center" valign="top">
                                        <div>方案永續性</div>
                                    </td>
                                    <td className="a5" align="center" valign="top">
                                        <div>18個月即中止</div>
                                    </td>
                                    <td className="a5" align="center" valign="top">
                                        <div className="win_c">
                                            <img src="./serviceImg/win.png" className="win6" alt="win"/>
                                        </div>
                                        <div>至少24個月，且得免費延長<br/>至通過考試為止<br/>跟著 AICPA 公告即時更新教材
                                        </div>
                                    </td>
                                    <td className="a5" align="left" valign="top" >
                                        「完成報名及資格審核，卻因疫情及工作影響遲遲未能投入時間準備，考試及唸書計畫也一延再延... 謝謝 Becker 讓我不需要額外付費，畢竟離報名課程已超過兩年。」
                                        <br/>—— 2023年9月通過全科考試
                                        <a className="text-danger text-decoration-underline" href="https://beckertw.com/art/535">Ryan</a>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className="a4 formt" align="center" valign="top">
                                        <div>完備性<br/>
                                        </div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div>目前僅3科
                                        </div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div className="win_c">
                                            <img src="./serviceImg/win.png" className="win7" alt="win"/>
                                        </div>
                                        <div>
                                            斥資百萬美元研發全6科已上架上線
                                        </div>
                                    </td>
                                    <td className="a4" align="left">
                                        <div>「Becker 有長期輔導經驗，學程內容跟著考情更新 (更新資料頻率高，尤其更新項目一定要熟讀，就是考點！)，能有效率的成功通關。」
                                        <br/>—— 2023年11月通過考試
                                        <a className="text-danger text-decoration-underline" href="https://beckertw.com/art/570">Barry Hsieh</a></div>
                                    </td>
                                </tr>
                            </table>
                            <div className="text-right">以上見證文章與人名，皆獲學員本人授權公開刊登</div>
                            <div className="safe">
                                <img className="cheack" src="./serviceImg/com_image_005.png" alt="com"/>
                                <div className="title2">
                                    降低重考風險，Becker CPA 最保險
                                </div>
                                <div className="sub">
                                    使用 Becker 達到 94% 考試通過率！ <a href="https://beckertw.com/art/326">(什麼是 Becker Bump?)</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container mt100">
                <div className="br mt100 mb100"></div>
                <div className="row">
                    <div className="col-6 coursevideo">
                        <div className="text-left mb-2">
                            全新專科「Business Analytics & Reporting (BAR)」第一單元，中文課前導讀 (試聽影片)
                        </div>
                        <iframe className="dis" width="560" height="315" src="https://www.youtube.com/embed/IM8PBAEKVD0?si=X7Q9V89NrbOzo2oj" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        <iframe className="mvideo" width="400" height="200" src="https://www.youtube.com/embed/IM8PBAEKVD0?si=X7Q9V89NrbOzo2oj" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <div className="col-6 coursevideo">
                        <div className="text-left mb-2">
                            全新專科「Information Systems & Control 資訊系統與控制 (ISC)」第一堂課，中文課前導讀 (試聽影片)
                        </div>
                        <iframe className="dis" width="560" height="315" src="https://www.youtube.com/embed/7JDSmkPRROs?si=rwxgZvvBxGuRh7YI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        <iframe className="mvideo" width="400" height="200" src="https://www.youtube.com/embed/7JDSmkPRROs?si=rwxgZvvBxGuRh7YI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="br mt100 mb100"></div>
                <div className="beckertitlename mt100 mb-5">選擇現在啟動考照計畫 Now is the time</div>
                <div className="text-center w-50 m-auto">
                    Becker Taiwan 即日起擴增 CPA 雙語課程（比 Becker 原文教材更多出約120小時之中文強化講解課程）以及上述貼心服務至北美及新加坡、香港、日本等地區，開放華人考生跨洋線上學習與使用。
                    想要快速通過考試取得美國會計師執照的華人考生，現在就是最好的啟動時機！<br/>
                    　
                    Becker Taiwan 現行優惠方案，讓您使用 Becker CPA 及中文雙語輔考課程教材，可持續展延使用期限，展延直到考上為止；您可自由任選時段於雲端看課，讓業界經驗豐富的中文 USCPA 講師，帶您入門美國商稅法、資訊科技、政府會計等會計本科都不一定修過的範疇，搭配講師系統整理之精華重點講義；您可全程在線上上課，且依個人需要隨選隨看。<br/>
                    　
                    把握 2024 考試黃金準備期，取得「不是工作選我，而是我來挑工作」的鍍金籌碼：準備USCPA，就是現在！
                </div>
                <div className="br mt100 mb100"></div>
            </div>
            <motion.div
                    initial={{ opacity: 0, x:-100 }}
                    whileInView={{ opacity: 1, x:0 }}
                    transition={{
                    delay: 0.3,
                    default: { ease: "linear" },
                }}>
            <div className="beckertitlename mt100 mb-5" id="whybeckertw">選擇 Becker 準備美國會計師考試 Why Becker CPA?</div>
            </motion.div>
            <motion.div
                    initial={{ opacity: 0, x:-100 }}
                    whileInView={{ opacity: 1, x:0 }}
                    transition={{
                    delay: 0.5,
                    default: { ease: "linear" },
                }}>
            <div className="text-center w-50 m-auto">
            在「能力當道 + 講求迅速」的現今，每十個美國會計師之中，就有九個是使用 Becker 通過考試成功；90%獲 Elijah Watt Sells Award 的考生得主都是 Becker 學員。<br/>
　
            然而，北美地區華人考生可能受限於留美時間短、對專業英文與對英美法陌生之故，常在考試準備上無法有效率地達標。
            </div>
            </motion.div>
            <div className="br mt100 mb100"></div>
                <motion.div
                        initial={{ opacity: 0, x:-100 }}
                        whileInView={{ opacity: 1, x:0 }}
                        transition={{
                        delay: 0.3,
                        default: { ease: "linear" },
                    }}>
                <div className="beckertitlename mt100 mb-5">選擇 Becker 台灣雙語課程與諮詢方案 Why Taiwan Becker CPA?</div>
                </motion.div>
                <motion.div
                        initial={{ opacity: 0, x:-100 }}
                        whileInView={{ opacity: 1, x:0 }}
                        transition={{
                        delay: 0.5,
                        default: { ease: "linear" },
                    }}>
                <div className="text-center w-75 m-auto">
                    Becker Taiwan 自2003年起，即推廣研發中文與英文雙語解說課程，協助跨科系、對英美法及專業英文陌生的華語考生們，快速理解並成功通過 USCPA 考試。Becker Taiwan 的 CPA 考生學員通過率高，2016 更獲 AICPA 高分肯定獎項 Elijah Watt Sells Award。在英語非母語的台灣，學員能獲有此殊榮，與台灣中文講師的精湛教學不無關係。<br/>
        　
                    Becker Taiwan 的 CPA 六科中文課程，皆聘請在該科領域上獨具專業背景的美國會計師。舉例來說，Regulation 科目講師亦持有美國律師資格；同時，內含大量資訊科技內容的 ISC 科目，授課講師即為 IT 專業背景的美國會計師。<br/>
        　
                    此外值得一提的是，Becker Taiwan 的 CPA 學員可獲得線上中文解題服務、使用中文解答知識庫、以及報名申請考試的行政手續全程輔導。
                </div>
                </motion.div>
            <div className="br mt100 mb100"></div>
            <div className="beckertitlename mt100 mb100" id="intro">捷進 Becker CPA方案介紹</div>
            
            <div className="container">
                <div className="row mt100">
                    <div className="col-4 pricecard">
                        <div className="card pdbox w-75 h-100">
                            <h5>專業方案</h5>
                            <div className="card-body">
                                <ul className="align-items-stretch">
                                    <li>CPA Exam Review 學習題庫軟體 (含 Flashcards)</li>
                                    <li>英文線上解題 (Academic Support)</li>
                                    <li className="text-danger">考程顧問諮詢輔導</li>
                                    <li className="text-danger"> 執照申請與台會抵免諮詢 (1小時 5,000元；提供備考經驗分享得2,000元優惠價)</li>
                                    <li className="text-danger">CPA Final Review 軟體</li>
                                    <li className="text-danger">完整四科中文課程</li>
                                    <li className="text-danger">中文線上單元導讀影片</li>
                                    <li className="text-danger">中文線上解題服務</li>
                                    <li className="text-danger">CPE Select 一年份執照進修課程</li>
                                </ul>
                            </div>
                            <div className="ugbk">
                                <h6>使用效期</h6>
                                <span>24個月+<span className="text-danger">持續展延</span></span>
                            </div>
                            <div className="ugbk">
                                <h6>適用客群</h6>
                                <span>帶職、在學備考者<br/>
                                並使用中文課程與線上解題服務</span>
                            </div>
                            <div className="cash">120,000</div>
                            
                            <Link to={`/registration?parent_id=1`} className="bt_prd">»報名與購買</Link>
                        </div>
                    </div>
                    <div className="col-4 pricecard">
                        <div className="card pdbox w-75 h-100">
                            <h5>全修方案</h5>
                            <div className="card-body">
                                <ul className="align-items-stretch">
                                    <li>CPA Exam Review 學習題庫軟體 (含 Flashcards)</li>
                                    <li>英文線上解題 (Academic Support)</li>
                                    <li className="text-danger">考程顧問諮詢輔導</li>
                                    <li className="text-danger"> 執照申請與台會抵免諮詢 (1小時 5,000元；提供備考經驗分享得2,000元優惠價)</li>
                                    <li className="text-danger">CPA Final Review 軟體</li>
                                    <li className="text-danger">完整四科中文課程</li>
                                    <li className="text-danger">中文線上單元導讀影片</li>
                                    <li className="text-danger">中文線上解題服務</li>
                                </ul>
                            </div>
                            <div className="ugbk">
                                <h6>使用效期</h6>
                                <span>24個月+<span className="text-danger">持續展延</span></span>
                            </div>
                            <div className="ugbk">
                                <h6>適用客群</h6>
                                <span>帶職、在學備考者<br/>
                                並使用中文課程與線上解題服務</span>
                            </div>
                            <div className="cash">113,000</div>
                            
                            <Link to={`/registration?parent_id=1`} className="bt_prd">»報名與購買</Link>
                        </div>
                    </div>
                    <div className="col-4 pricecard">
                        <div className="card pdbox w-75 h-100">
                            <h5>選修方案</h5>
                            <div className="card-body">
                                <ul className="align-items-stretch">
                                    <li>CPA Exam Review 學習題庫軟體 (含 Flashcards)</li>
                                    <li>英文線上解題 (Academic Support)</li>
                                    <li className="text-danger">三次考程顧問諮詢輔導</li>
                                    <li className="text-danger">執照申請與台會抵免諮詢 (1小時 5,000元；提供備考經驗分享得2,000元優惠價)</li>
                                    <li className="text-danger">任選6堂中文課程</li>
                                    <li className="text-danger">CPA Final Review 軟體</li>
                                </ul>
                            </div>
                            <div className="ugbk">
                                <h6>使用效期</h6>
                                <span>24個月</span>
                            </div>
                            <div className="ugbk">
                                <h6>適用客群</h6>
                                <span>留學生、僅須重點中文課程者</span><br/>
                            </div>
                            <div className="cash">80,000</div>
                            
                            <Link to={`/registration?parent_id=1`} className="bt_prd">»報名與購買</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container mt100">
                <div className="row">
                    <div className="col-4 pricecard">
                        <div className="card pdbox w-75 h-100">
                            <h5>自修方案</h5>
                            <div className="card-body">
                                <ul className="align-items-stretch">
                                    <li>CPA Exam Review 學習題庫軟體 (含 Flashcards)</li>
                                    <li>英文線上解題 (Academic Support)</li>
                                </ul>
                            </div>
                            <div className="ugbk">
                                <h6>使用效期</h6>
                                <span>24個月</span>
                            </div>
                            <div className="ugbk">
                                <h6>適用客群</h6>
                                <span>留學生、全自修者<br/>
                                並使用中文課程與線上解題服務</span>
                            </div>
                            <div className="cash">75,000</div>
                            
                            <Link to={`/registration?parent_id=1`} className="bt_prd">»報名與購買</Link>
                        </div>
                    </div>
                    <div className="col-4 pricecard">
                        <div className="card pdbox w-75 h-100">
                            <h5>單科雙語</h5>
                            <div className="card-body">
                                <ul className="align-items-stretch">
                                    <li>CPA Exam Review 學習題庫軟體 (含 Flashcards)</li>
                                    <li>英文線上解題 (Academic Support)</li>
                                    <li>單科中文課程</li>
                                </ul>
                            </div>
                            <div className="ugbk">
                                <h6>使用效期</h6>
                                <span>24個月</span>
                            </div>
                            <div className="ugbk">
                                <h6>適用客群</h6>
                                <span>已通過部分科目者</span>
                            </div>
                            <div className="cash">45,000</div>
                            
                            <Link to={`/registration?parent_id=1`} className="bt_prd">»報名與購買</Link>
                        </div>
                    </div>
                    <div className="col-4 pricecard">
                        <div className="card pdbox w-75 h-100">
                            <h5>購買方式</h5>
                            <div className="card-body">
                                <ul className="align-items-stretch">
                                    <li>點選套組下方「了解更多」，即可查看線上報名表。</li>
                                    <li>欲購買教材並報名課程，請填寫報名表並依說明完成匯款；我們在收到表單資料後，將有專人於當日與您聯絡。</li>
                                </ul>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div className="beckertitlename mt100 mb-5">甚麼是持續展延？</div>
            <div className="text-center w-50 m-auto mb100">
            Becker 公定使用效期為24個月，到期時若有尚未通過的科目，告知 Becker，即可免費展延該科目的使用效期。<br/>
            每次免費展延6個月，可無限次展延，直到通過該科考試為止。<br/>
            <span className="text-danger">以上加值服務之項目與內容，本公司將保留變更、終止、修改及解釋之權利。</span>
            <div className="br mt100 mb100"></div>
            </div>
            <div className="container-fluid wt xx_pc">
                <div className="beckertitlename mt100"  id="twus">台灣與美國<br/>
                    購買Becker教材比較</div>
                <div className="row adt">
                    <div className="col-sm-5 cpm">
                        <div className="cpl titcp">
                            <br/> 美國/USA
                        </div>
                    </div>
                    <div className="col-sm-2 cpit cpt titcp">v.s.</div>
                    <div className="col-sm-5 cpm">
                        <div className="cpr titcp">
                            <br/> 台灣/TAIWAN
                        </div>
                    </div>
                </div>
                <div className="row cpe adt">
                    <div className="col-sm-5 cpm">
                        <div className="cpl">
                            Becker CPA Exam Review
                            <br/> 培訓軟體
                        </div>
                    </div>
                    <div className="col-sm-2 cpit cpt">產
                        <br/>品
                    </div>
                    <div className="col-sm-5 cpm">
                        <div className="cpr">Becker CPA Exam Review
                            <br/> 培訓軟體
                        </div>
                    </div>
                </div>
                <div className="row cpe eg adt">
                    <div className="col-sm-5 cpm">
                        <div className="cpl">
                            <br/> USD 2,499
                        </div>
                    </div>
                    <div className="col-sm-2 cpit epg cpt">價
                        <br/>格
                    </div>
                    <div className="col-sm-5 cpm">
                        <div className="cpr"><span className="egs">★★★★★</span>
                            <br/> NTD 113,000
                            <br/>
                            <span className="red">售價與美國同步，再贈中文加值服務</span>
                        </div>
                    </div>
                </div>
                <div className="row cpe eb adt">
                    <div className="col-sm-5 cpm">
                        <div className="cpl">
                            <br/> 美籍全英語教學
                            <br/> 四科
                        </div>
                    </div>
                    <div className="col-sm-2 cpit epb cpt">授
                        <br/>課
                        <br/>方
                        <br/>式
                    </div>
                    <div className="col-sm-5 cpm">
                        <div className="cpr"><span className="ebs">★★★★★</span>
                            <br/> 美籍全英語教學
                            <br/> 四科
                            <br/>
                            <span className="red">四科中文精華課程 + 全科中文雲端導讀</span>
                        </div>
                    </div>
                </div>
                <div className="row cpe ed adt">
                    <div className="col-sm-5 cpm">
                        <div className="cpl">
                            <br/> 無
                        </div>
                    </div>
                    <div className="col-sm-2 cpit epd cpt">顧
                        <br/>問
                        <br/>諮
                        <br/>詢
                    </div>
                    <div className="col-sm-5 cpm">
                        <div className="cpr"><span className="eds">★★★★★</span>
                            <br/>
                            <span className="red">考程 3 階段顧問諮詢與文件檢核服務：<br/>
                                ◆ 學歷認證、報名考試、預約考場<br/>
                                通過考試後，依學員需求可預約：<br/>
                                ◆ 執照申請與台會抵免諮詢 (1小時 5,000元；提供備考經驗分享得2,000元減免)</span>
                        </div>
                    </div>
                </div>
                <div className="row cpe ex adt">
                    <div className="col-sm-5 cpm">
                        <div className="cpl">
                            <br/> Academic Support 軟體線上發問系統
                            <br/> 48小時英文解題回覆服務
                        </div>
                    </div>
                    <div className="col-sm-2 cpit epx cpt">解
                        <br/>題
                        <br/>服
                        <br/>務
                    </div>
                    <div className="col-sm-5 cpm">
                        <div className="cpr"><span className="exs">★★★★★</span>
                            <br/> Academic Support 軟體線上發問系統
                            <br/> 48小時英文解題回覆服務
                            <br/>
                            <span className="red">中文解題知識庫：進入題庫搜尋問題解析<br/>
                                中文解題知識庫：進入題庫搜尋問題解析<br/>
                                中文線上發問系統：中文發問、中文回覆
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <section className="plan-compare d-none d-md-block">
                <div className="beckertitlename mt100 mb100" id="plan">方案比較</div>
                    <div className="container mb100">
                        <div className="row">
                            <div className="compare" >
                                <table className="text-center">
                                    <tr>
                                        <td nowrap="">
                                            <div className="a1">專業方案</div>
                                        </td>
                                        <td nowrap="">
                                            <div className="a1">全修方案</div>
                                        </td>
                                        <td nowrap="">
                                            <div className="a1">選修方案</div>
                                        </td>
                                        <td nowrap="">
                                            <div className="a1">自修方案</div>
                                        </td>
                                    </tr>
                                    <tr className="xxx-hide">
                                        <td colspan="5">
                                            <div className="a2">適合客群</div>
                                        </td>
                                    </tr>
                                    <tr className="xxx-hide">
                                        <td className="a3" align="left" valign="top">
                                            <div>以取得執照為目標的財務會計業界人士</div>
                                        </td>
                                        <td className="a3" align="left" valign="top">
                                            <div>習慣搭配中文學習輔助、與同儕切磋、節省自行摸索時間、避免繁瑣手續者</div>
                                        </td>
                                        <td className="a3" align="left" valign="top">
                                            <div>仍在職或在學、僅需重點單元的中文課程、欲節省自行摸索時間、避免繁瑣手續者</div>
                                        </td>
                                        <td className="a3" align="left" valign="top">
                                            <div>有自信短期內通過考試、不需中文課程者</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">CPA Exam Review 學習軟體</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">100+ 小時美師授課影片（英字幕）</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">1300 電子閃字卡 (Flashcards)</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">6,700+ 練習題庫</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">3 套期中考 + 2 套模擬考 </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">70+ 小時美師解題影片（英文字幕）</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                    </tr>
                                    {/* <tr>
                                        <td colspan="5">
                                            <div className="a2">四本 Exam Review 紙本教科書</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                    </tr> */}
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">外師線上解題服務 (英文)</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">CPA Final Review 總複習軟體</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">35+ 小時美師總複習影片（英文字幕）</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">800+ 總複習練習題庫</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">1 套全真模擬考 </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">考程顧問諮詢輔導</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">三次</div>
                                        </td>
                                        <td>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">中文課程（實體面授、實體數位、雲端觀看）</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">4科</div>
                                        </td>
                                        <td>
                                            <div className="a3">4科</div>
                                        </td>
                                        <td>
                                            <div className="a3">6堂</div>
                                        </td>
                                        <td>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">中師線上解題服務 (中文)</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>

                                        </td>
                                        <td>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">30+ 小時中師導讀與解題影片</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>

                                        </td>
                                        <td>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">All In One 國際就業力線上課程</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>

                                        </td>
                                        <td>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">執照延續進修課程 CPE 一年份訂閱</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3">✔</div>
                                        </td>
                                        <td>

                                        </td>
                                        <td>

                                        </td>
                                        <td>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">軟體效期</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3"><a href="#pp1">24個月</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp2">24個月</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp3">24個月</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp4">24個月</a></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3"><a href="#pp1">✔</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp2">✔</a></div>
                                        </td>
                                        <td>
                                        </td>
                                        <td>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">方案定價</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3"><a href="#pp1">NT$120,000</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp2">NT$113,000</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp3">NT$80,000</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp4">NT$75,000</a></div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div className="compare">
                                <table className="text-center">
                                    <tr className="xxx-hide">
                                        <td colspan="5">
                                            <div className="a1">Becker Taiwan 學員專屬加購功能</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td nowrap="">
                                            <div className="a1">專業方案</div>
                                        </td>
                                        <td nowrap="">
                                            <div className="a1">全修方案</div>
                                        </td>
                                        <td nowrap="">
                                            <div className="a1">選修方案</div>
                                        </td>
                                        <td nowrap="">
                                            <div className="a1">自修方案</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">可付費或是提供心得文享優惠減免申請取照諮詢</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3"><a href="#pp1">✔</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp2">✔</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp3">✔</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp4">✔</a></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">可加購中文課程堂數</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3"><a href="#pp1">✔</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp2">✔</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp3">✔</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp4">✔</a></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">可選修加州州立大學合作學分班</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3"><a href="#pp1">✔</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp2">✔</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp3">✔</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp4">✔</a></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">可加購持續展延 Unlimited Access</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                        </td>
                                        <td>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp3">✔</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp4">✔</a></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">可加購 Final Review 總複習</div>
                                        </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    </td>
                                    <td>
                                    </td>
                                    <td>
                                        <div className="a3"><a href="#pp3">✔</a></div>
                                    </td>
                                    <td>
                                        <div className="a3"><a href="#pp4">✔</a></div>
                                    </td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <div className="a2">購買 CMA (美國管理會計師) 享學員優惠</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="a3"><a href="#pp3">✔</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp3">✔</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp3">✔</a></div>
                                        </td>
                                        <td>
                                            <div className="a3"><a href="#pp4">✔</a></div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    
                    <div className="container-fluid ueit">
                        <div className="marbk width_c">
                            <h3>最適合華人考生的備考方案</h3>
                            購買 Becker Taiwan CPA 全修方案，即可獲得 四科中文課程使用額度，可於軟體有效期間於 Becker Taiwan 中文雲端教室隨選隨看，再加贈40小時額外補課用時數，
                            更可於線上解題專區，向台灣講師發問、獲得中文解題，亦可隨時搜尋歷史問答解題資料庫，獲得相關解題說明；
                            中文課程為 Becker Taiwan 專聘持有美國會計師/美國律師資格之台灣在職資深講師，所開設之精華衝刺課程，同時搭配可使用至考上為止之 Becker CPA Exam 教材軟體、美師完整授課影片 (中英字幕)、7,000+題庫、3套全真模擬考試、美師線上解答，另含報考行政流程完整諮詢輔導服務。
                        </div>
                    </div>
                    </section>
            </div>
        </>
    );
}
export default Cpa;